import 'antd/lib/button/style';
//# sourceMappingURL=index.js.map